/**
 * Decorative eGK-card-into-reader illustration shown while the kiosk waits for
 * a card. Mirrors the prototype's looping insert animation; the loop and the
 * status-LED pulse are disabled under `prefers-reduced-motion` (the card simply
 * rests inserted). Purely decorative — hidden from assistive tech.
 */
export function CardInsertAnimation() {
  return (
    <div className="kiosk-card-insert" aria-hidden>
      <div className="kiosk-egk" />
      <div className="kiosk-reader" />
      <style>{`
        .kiosk-card-insert {
          position: relative; width: 320px; height: 260px; max-width: 100%;
          overflow: hidden; border-radius: 12px;
        }
        .kiosk-card-insert .kiosk-egk {
          position: absolute; left: 50%; top: 0;
          transform: translate(-50%, 0) rotate(-4deg);
          width: 220px; height: 138px; overflow: hidden; border-radius: 16px;
          background: linear-gradient(135deg, oklch(0.94 0.025 250), oklch(0.86 0.04 250));
          box-shadow:
            0 1px 0 oklch(1 0 0 / 0.6) inset,
            0 12px 30px -10px oklch(0.30 0.10 269 / 0.35),
            0 2px 6px oklch(0.30 0.10 269 / 0.2);
          animation: kioskCardInsert 2.6s cubic-bezier(0.5, 0, 0.2, 1) infinite;
        }
        .kiosk-card-insert .kiosk-egk::before {
          content: ""; position: absolute; left: 18px; top: 50px;
          width: 38px; height: 30px; border-radius: 4px;
          background: linear-gradient(135deg, oklch(0.78 0.08 80), oklch(0.65 0.12 75));
        }
        .kiosk-card-insert .kiosk-egk::after {
          content: "AOK"; position: absolute; right: 14px; top: 12px;
          font-size: 10px; font-weight: 700; letter-spacing: 0.1em;
          color: oklch(0.30 0.10 155); opacity: 0.7;
        }
        .kiosk-card-insert .kiosk-reader {
          position: absolute; left: 50%; bottom: 0; transform: translateX(-50%);
          width: 280px; height: 90px; max-width: 100%; z-index: 2;
          background: var(--foreground-ink);
          border-radius: 14px 14px 6px 6px;
          box-shadow:
            inset 0 4px 8px oklch(0 0 0 / 0.4),
            0 -2px 6px oklch(0.30 0.10 269 / 0.18);
        }
        .kiosk-card-insert .kiosk-reader::before {
          content: ""; position: absolute; left: 50%; top: 10px; transform: translateX(-50%);
          width: 230px; height: 6px; border-radius: 4px;
          corner-shape: round;
          background: oklch(0 0 0 / 0.75);
          box-shadow: 0 1px 0 oklch(1 0 0 / 0.06);
        }
        .kiosk-card-insert .kiosk-reader::after {
          content: ""; position: absolute; right: 18px; bottom: 14px;
          width: 8px; height: 8px; border-radius: 999px;
          corner-shape: round;
          background: var(--success-vivid); box-shadow: 0 0 8px var(--success);
          animation: kioskLedPulse 1.6s ease-in-out infinite;
        }
        @keyframes kioskCardInsert {
          0%   { transform: translate(-50%, -40%) rotate(-4deg); opacity: 0.55; }
          35%  { transform: translate(-50%, 45%) rotate(-1deg); opacity: 1; }
          65%  { transform: translate(-50%, 45%) rotate(-1deg); opacity: 1; }
          100% { transform: translate(-50%, -40%) rotate(-4deg); opacity: 0.55; }
        }
        @keyframes kioskLedPulse {
          0%, 100% { opacity: 0.6; }
          50%      { opacity: 1; }
        }
        @media (prefers-reduced-motion: reduce) {
          .kiosk-card-insert .kiosk-egk {
            animation: none;
            transform: translate(-50%, 30%) rotate(-2deg);
          }
          .kiosk-card-insert .kiosk-reader::after { animation: none; }
        }
      `}</style>
    </div>
  );
}
